import { render, staticRenderFns } from "./IncurablePatient.vue?vue&type=template&id=bedb5872&"
import script from "./IncurablePatient.vue?vue&type=script&lang=js&"
export * from "./IncurablePatient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports